import { Injectable } from '@angular/core';
import { StringUtilsService } from './string.utils.service';
import { DateUtilsService } from './dateUtils';
import { PostProcessHttpResponseService } from './post-process-http-response.service';
import { PostProcessHttpResponseCurrencyService } from './post-process-http-response-currency.service';

@Injectable({
  providedIn: 'root'
})
export class CfMockService {

  private currentMapOfPaidInvoicesViaCF = {};
  private cfGeneratedInvoices = [];
  private currentCFBalance = 51000;
  private utilizedCF = 23000


  constructor(
    private stringUtilsService: StringUtilsService,
    private dateUtils: DateUtilsService,
    private postProcessRespForCurrency: PostProcessHttpResponseCurrencyService
  ) { }

  payCFInvoice(payData) {
    if (payData.bankAmt < this.currentCFBalance) {
      // Add invoices to map of paid invoices via CF
      payData.selectedInvoices.forEach(inv => {
        this.currentMapOfPaidInvoicesViaCF[inv.docId] = inv;
        console.log(inv);
        const docAmt = this.stringUtilsService.roundNoToTwoDecimal(inv.dueAmt + (inv.dueAmt * 0.05));
        const newLRPINV = {
          buyerCode: inv.buyerCode,
          buyerName: inv.buyerName,
          currCode: inv.currCode,
          disablePay: false,
          docAmt,
          docDate: this.dateUtils.getFormattedDate(),
          docDetail: { docAmt },
          docId: 'LRP' + inv.docId,
          docNo: 'LRP' + inv.docNo,
          docType: 'LRP',
          docTypeDesc: 'LRP',
          dueAmt: docAmt,
          dueDate: this.dateUtils.getFormattedDate(this.dateUtils.addDaysToDate(this.dateUtils.getToday(), 45)),
          multipayTag: 'LRP' + inv.docNo,
          sellerCode: inv.sellerCode,
          sellerName: 'Lender',
          sellerNm: 'Lender',
          status: 'UNPAID',
          ts: inv.ts,
          imgUrl: `https://qa.payex.live/PayEXDCAPI/static/seller-assets/lender/unnamed.webp`

        };
        this.postProcessRespForCurrency.processInvoice(newLRPINV);
        this.cfGeneratedInvoices.push(newLRPINV);
      });
      this.currentCFBalance -= (payData.bankAmt + (payData.surchargeData?.surchargeFee || 0));
      this.utilizedCF += payData.bankAmt + (payData.surchargeData?.surchargeFee || 0);
      return true;
    } else {
      return false;
    }
  }

  checkIfInvoicesPaidViaCFMock(docId) {
    return this.currentMapOfPaidInvoicesViaCF[docId];
  }

  getCurrentCFData() {
    return { currentCFBalance: this.currentCFBalance, utilizedCF: this.utilizedCF };
  }

  getCurrentCFGeneratedInvoices() {
    return this.cfGeneratedInvoices;
  }
}
